import { render } from "./CashMovementImage.vue?vue&type=template&id=64c7279b"
import script from "./CashMovementImage.vue?vue&type=script&lang=js"
export * from "./CashMovementImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__